export default __webpack_public_path__ + "static/media/mw.331c66ef.jpg";